var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-stories-article-illustrated-main-img-asset",class:{
        'c-stories-article-illustrated-main-img-asset--visible': _vm.isVisible,
        'c-stories-article-illustrated-main-img-asset--first': _vm.indexImg === 0
    },style:(("--z-index-asset: " + (_vm.indexImg + 1)))},[_c('asset',{attrs:{"asset":_vm.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }